import { ACTIVE_INCENTIVES_VOCABULARIES } from './active-incentives.js';
/** Slice d490 of the catalog (D577): the vocabularies the active incentives and the rider zone discount (D490) brought. */
export const SLICE_D490 = [...ACTIVE_INCENTIVES_VOCABULARIES];
//# sourceMappingURL=slice-d490.js.map